var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"graph-stats"},[_c('div',{staticClass:"graph-header"},[_c('h4',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"-wrapper"},[_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }